import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, Grid2, TextField, Typography } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import classnames from "classnames";
import DatePickerRange from "components/common/DatePickerRange";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "../common/Select";
import { actions } from "./logic/formActions";
import { styles } from "./styles";

import { AccordionSummary } from "@mui/material";
import "./styles.css";

const FilmInformationForm = (props) => {
    useEffect(() => {}, []);

    const [filmCodeValueState, setFilmCodeValueState] = useState("");
    const [ratingReasonState, setRatingReasonState] = useState("");

    useEffect(() => {
        if (filmCodeValueState) setFilmCodeValueState("");
        if (ratingReasonState) setRatingReasonState("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.searchFormCleared]);

    const expandPanelStyle = useStyles();

    const {
        classes,
        filmCode,
        filmRatingCode,
        filmCodeTypes,
        filmRatingTypes,
        filmDateCertifiedStart,
        filmDateCertifiedEnd,
        filmReleaseDateStart,
        filmReleaseDateEnd,
        filmEnteredDateStart,
        filmEnteredDateEnd,
        onChange,
    } = props;

    const filmCoTypes = filmCodeTypes.map((type) => ({ value: type.id, label: type.name }));
    const filmRaTypes = filmRatingTypes.map((type) => ({ value: type.id, label: type.abbreviation }));

    const handleInputChange = (e) => {
        e.persist();
        if (e.keyCode !== 13 && e.target.value !== "") {
            switch (e.target.name) {
            case "filmCodeValue":
                setFilmCodeValueState(e.target.value);
                break;
            case "ratingReason":
                setRatingReasonState(e.target.value);
                break;
            default:
                break;
            }
        } else {
            onChange(e);

            if (e.target.value === "")
                switch (e.target.name) {
                case "filmCodeValue":
                    setFilmCodeValueState(e.target.value);
                    break;
                case "ratingReason":
                    setRatingReasonState(e.target.value);
                    break;
                default:
                    break;
                }
        }
    };

    return (
        (<Grid2 container >
            <Accordion className={expandPanelStyle.root}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={expandPanelStyle.summary}>
                    <Typography>Film Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={expandPanelStyle.details}>
                    <Grid2 container spacing={2}>
                        <Grid2
                            className={classnames(expandPanelStyle.item, expandPanelStyle.selectWrapper)}
                            size={{
                                xs: 12,
                                sm: 12,
                                md: 12
                            }}>
                            <Select
                                placeholder="Code"
                                value={filmCode}
                                defaultMenuPortalTarget
                                onChange={(e) => onChange({ target: { value: e, name: "filmCode" } })}
                                options={filmCoTypes}
                            />
                        </Grid2>
                        {}
                        <Grid2
                            className={classnames(expandPanelStyle.item, expandPanelStyle.selectWrapper)}
                            size={12}
                        >
                            <Select
                                placeholder="Rating"
                                value={filmRatingCode}
                                defaultMenuPortalTarget
                                onChange={(e) => onChange({ target: { value: e, name: "filmRatingCode" } })}
                                options={filmRaTypes}
                            />
                        </Grid2>
                        <Grid2 className={expandPanelStyle.item} padding={1} size={12}>
                            <TextField
                                id="outlined-basic"
                                className={classes.formControl}
                                label="Rating Reason"
                                margin="normal"
                                variant="outlined"
                                name="ratingReason"
                                value={ratingReasonState}
                                onChange={handleInputChange}
                                onKeyUp={handleInputChange}
                            />
                        </Grid2>
                        <Grid2 container padding={2} size={12}>
                            <DatePickerRange
                                dateName="Certified"
                                fieldName="filmDateCertified"
                                start={props.searchFormCleared ? null : filmDateCertifiedStart}
                                end={props.searchFormCleared ? null : filmDateCertifiedEnd}
                                onChange={(field) =>
                                    onChange({
                                        target: {
                                            name: Object.entries(field)[0][0],
                                            value: Object.entries(field)[0][1],
                                        },
                                    })
                                }
                                startSuffix="Start"
                                endSuffix="End"
                            />
                        </Grid2>
                        <Grid2 container padding={2} size={12}>
                            <DatePickerRange
                                dateName="Release"
                                fieldName="filmReleaseDate"
                                start={props.searchFormCleared ? null : filmReleaseDateStart}
                                end={props.searchFormCleared ? null : filmReleaseDateEnd}
                                onChange={(field) =>
                                    onChange({
                                        target: {
                                            name: Object.entries(field)[0][0],
                                            value: Object.entries(field)[0][1],
                                        },
                                    })
                                }
                                startSuffix="Start"
                                endSuffix="End"
                            />
                        </Grid2>
                        <Grid2 container padding={2} className="last-date" size={12}>
                            <DatePickerRange
                                dateName="Entered"
                                fieldName="filmEnteredDate"
                                start={props.searchFormCleared ? null : filmEnteredDateStart}
                                end={props.searchFormCleared ? null : filmEnteredDateEnd}
                                onChange={(field) =>
                                    onChange({
                                        target: {
                                            name: Object.entries(field)[0][0],
                                            value: Object.entries(field)[0][1],
                                        },
                                    })
                                }
                                startSuffix="Start"
                                endSuffix="End"
                            />
                        </Grid2>
                    </Grid2>
                </AccordionDetails>
            </Accordion>
        </Grid2>)
    );
};

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    summary: {
        minHeight: "45px",
        height: "45px",
    },
    item: {
        display: "flex",
    },
    details: {
        flexDirection: "column",
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
    },
    date: {
        display: "flex",
        paddingLeft: 5,
        paddingRight: 5,
        marginTop: 5,
        marginBottom: 10,
    },
    selectWrapper: {
        padding: 8,
    },
    labelByHand: {
        paddingLeft: 10,
        paddingBottom: 5,
        color: "#808080",
        width: "100%",
    },
    datepickerLeft: {
        paddingLeft: 0,
    },
    datepickerRight: {
        paddingRight: 0,
    },
});

FilmInformationForm.propTypes = {
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    advertising: {
        form: {
            filmCode,
            filmCodeValue,
            ratingReason,
            filmRatingCode,
            filmDateCertifiedStart,
            filmDateCertifiedEnd,
            filmReleaseDateStart,
            filmReleaseDateEnd,
            filmEnteredDateStart,
            filmEnteredDateEnd,
        },

        searchFormCleared,
    },
    globalApp,
}) => ({
    filmCodeTypes: globalApp.filmCodeTypes,
    filmRatingTypes: globalApp.filmRatingTypes,
    filmCode,
    filmCodeValue,
    ratingReason,
    filmRatingCode,
    filmDateCertifiedStart,
    filmDateCertifiedEnd,
    filmReleaseDateStart,
    filmReleaseDateEnd,
    filmEnteredDateStart,
    filmEnteredDateEnd,
    searchFormCleared,
});

const mapDispatchToProps = (dispatch) => ({
    getFilmCodeTypes: (url) => dispatch(actions.GET_FILM_CODE_TYPE.send(url)),
    getFilmRatingTypes: (url) => dispatch(actions.GET_FILM_RATING_TYPE.send(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FilmInformationForm));
